import { Component, input, signal } from '@angular/core';
import { Icon } from '../../shared/components/icon';
import { Divider } from '../../shared/components/divider';
import { MenuItem } from '../../shared/models/menu-item';

@Component({
  selector: 'app-menu-mobile',
  template: `
  <div class="text-{{color()}}">
    <ul>
        @for (item of menuItems(); track $index) {
            <li>
              <app-divider [isOrizontalDivider]="true" borderColor="border-{{color()}} opacity-10"/>
              <button (click)="item.items.length > 0 ? toggleMenu($index) : null"
                class="flex justify-between items-center w-full py-7 cursor-pointer px-3">
                @if(item.items.length > 0) {
                  <span class="uppercase font-semibold text-sm">{{item.title}}</span>
                    <app-icon iconName="chevronDown" [stroke]="color()" className="w-6 h-6"
                      [class.rotate-180]="openMenuIndex() === $index" />
                } @else {
                  <li class="uppercase font-semibold text-sm"><a [href]="item.href">{{item.title}}</a></li>
                }
              </button>
              @if(openMenuIndex() === $index) {
              <ul class="py-3 px-4 space-y-10">
                @for (menuItem of item.items; track menuIdx; let menuIdx = $index) {
                    @if(menuItem.itemLinks && menuItem.itemLinks.length > 0) {
                        <li>
                          <div class="flex justify-between items-center">
                            <button (click)="toggleNestedMenu($index, menuIdx)"
                              class="flex items-center justify-center gap-1 py-2">
                                <app-icon [iconName]="isNestedMenuOpen($index, menuIdx) ? 'minus' : 'plus'"
                                  [stroke]="color()" className="w-3 h-3 opacity-25" />
                              <span class="uppercase font-light text-sm">{{menuItem.title}}</span>
                            </button>
                          </div>
                          @if(isNestedMenuOpen($index, menuIdx)) {
                          <ul class="pt-2 pl-5 space-y-3">
                            @for (itemLink of menuItem.itemLinks; track $index) {
                                <li><a [href]="itemLink.href" target="_blank" rel="noopener noreferrer" class="block py-1 font-light text-sm text-{{color()}} capitalize">{{itemLink.label}}</a></li>
                            }
                          </ul>
                          }
                        </li>
                      } @else {
                        <li><a [href]="menuItem.href" target="_blank" rel="noopener noreferrer" class="block py-1 font-light text-sm text-{{color()}} capitalize">{{menuItem.title}}</a></li>
                      }
                  }
              </ul>
              }
            </li>
        }
    </ul>
  </div>
    `,
  imports: [Icon, Divider]
})
export class MenuMobile {
  menuItems = input.required<MenuItem[]>();
  color = input<string>("white");

  openMenuIndex = signal<number | null>(null);
  openNestedMenuIndex = signal<string | null>(null);

  toggleMenu(index: number) {
    const isClosing = this.openMenuIndex() === index;

    this.openNestedMenuIndex.set(null);
    this.openMenuIndex.set(isClosing ? null : index);
  }

  toggleNestedMenu(parentIndex: number, childIndex: number) {
    const key = `${parentIndex}-${childIndex}`;
    const currentKey = this.openNestedMenuIndex();

    this.openNestedMenuIndex.set(currentKey === key ? null : key);
  }

  isNestedMenuOpen(parentIndex: number, childIndex: number): boolean {
    return this.openNestedMenuIndex() === `${parentIndex}-${childIndex}`;
  }
}